import request from '@/utils/request'
// 注册
export function register(data) {
	return request({
		url: 'register/register',
		method: 'post',
		data
	})
}
// 获取验证码
export function sendSms(data) {
	return request({
		url: 'register/sendSms',
		method: 'post',
		data
	})
}

// 登录
export function login(data) {
	return request({
		// url: 'passport/login',
		url: 'V1/passport/login',
		method: 'post',
		data
	})
}
// 退出登录
export function logout(data) {
	return request({
		url: 'passport/logout',
		method: 'post',
		data
	})
}
// 获取用户信息
export function getInfo(data) {
	return request({
		url: 'user/info',
		method: 'post',
		data
	})
}

// 修改用户信息
export function editinfo(data) {
	return request({
		url: 'user/editinfo',
		method: 'post',
		data
	})
}

// 修改头像
export function editavatar(data) {
	return request({
		url: 'user/editavatar',
		method: 'post',
		data
	})
}

// 忘记密码
export function forgetPwd(data) {
	return request({
		// url: 'register/password',
		url: 'V1/passport/update_password',
		method: 'post',
		data
	})
}

// 检测手机是否存在
export function checkMobile(data) {
	return request({
		// url: 'register/checkMobile',
		url: 'V1/passport/check_mobile',
		method: 'post',
		data
	})
}

// 网站配置接口
export function getConfig(data) {
	return request({
		url: 'config/get_setting',
		method: 'post',
		data
	})
}

// 采购额数据统计
export function dataSummary(data) {
	return request({
		url: 'user/datasummary',
		method: 'post',
		data
	})
}

// 充值 生成订单接口
export function userRecharge(data) {
	return request({
		url: 'user/user_recharge',
		method: 'post',
		data
	})
}

// 获取官方收款账户
export function getAccount(data) {
	return request({
		url: 'user/get_collection_account',
		method: 'post',
		data
	})
}

// 线下充值提交申请-
export function offlineRecharge(data) {
	return request({
		url: 'user/offline_recharge',
		method: 'post',
		data
	})
}

// 申请提现
export function applyCash(data) {
	return request({
		url: 'user/apply_cash',
		method: 'post',
		data
	})
}

// 获取交易记录
export function getCapitalRecord(data) {
	return request({
		url: 'user/get_capitals_record',
		method: 'post',
		data
	})
}

// 获取充值记录
export function getRechargeRecord(data) {
	return request({
		url: 'user/get_recharge_record',
		method: 'post',
		data
	})
}

// 获取提现记录
export function getCashRecord(data) {
	return request({
		url: 'user/get_user_cash',
		method: 'post',
		data
	})
}

// 获取历史数据统计
export function getDataBoard(data) {
	return request({
		url: 'user/data_board',
		method: 'post',
		data
	})
}

// 获取商品数据统计
export function goodsDataBoard(data) {
	return request({
		url: 'user/goods_data_board',
		method: 'post',
		data
	})
}

// 获取今日实时数据统计
export function getRealtimeBoard(data) {
	return request({
		url: 'user/real_time_board',
		method: 'post',
		data
	})
}

// 申请api的key和secret
export function applyKeySecret(data) {
	return request({
		url: 'user/apply_key_secret',
		method: 'post',
		data
	})
}

// app详情
export function getAppInfo(data) {
	return request({
		url: 'user/get_api_info',
		method: 'post',
		data
	})
}

// 编辑IP地址
export function setIp(data) {
	return request({
		url: 'user/set_ip',
		method: 'post',
		data
	})
}

// 编辑回调地址
export function setCallbackUrl(data) {
	return request({
		url: 'user/set_callback_url',
		method: 'post',
		data
	})
}

// 获取订阅列表
export function getSubscribeList(data) {
	return request({
		url: 'user/get_subscribe_list',
		method: 'post',
		data
	})
}

// 设置订阅状态
export function setSubscribe(data) {
	return request({
		url: 'user/set_subscribe',
		method: 'post',
		data
	})
}

// 联系客服
export function contactMsg(data) {
	return request({
		url: 'https://serviceapi.ecombird.com/api/service/add',
		method: 'post',
		data
	})
}

// 设置是否开启预警
export function change_warning(data) {
	return request({
		url: 'user/change_warning',
		method: 'post',
		data
	})
}

// 设置预警值
export function set_warning_value(data) {
	return request({
		url: 'user/set_warning_value',
		method: 'post',
		data
	})
}

// 客户经理
export function admin_info(data) {
	return request({
		url: 'user/admin_info',
		method: 'post',
		data
	})
}

// 导出交易记录
export function export_capitals_record(data) {
	return request({
		url: 'user/export_capitals_record',
		method: 'post',
		data
	})
}

// 获取可提现金额
export function get_can_cash(data) {
	return request({
		url: 'user/get_can_cash',
		method: 'post',
		data
	})
}

// 选择提现账户列表
export function accountList(data) {
	return request({
		url: 'userwithdrawal/accountList',
		method: 'post',
		data
	})
}

// 有赞授权商铺列表
export function yz_list(data) {
	return request({
		url: 'yz/list',
		method: 'post',
		data
	})
}

// 有赞授权商铺添加/修改
export function yz_save(data) {
	return request({
		url: 'yz/save',
		method: 'post',
		data
	})
}

// 有赞授权商铺删除
export function yz_delete(data) {
	return request({
		url: 'yz/delete',
		method: 'post',
		data
	})
}

// 有赞店铺授权
export function yz_authorize(data) {
	return request({
		url: 'yz/authorize',
		method: 'post',
		data
	})
}

// 分类加价率列表
export function category_increase_list(data) {
	return request({
		url: 'yz/category_increase_list',
		method: 'post',
		data
	})
}

// 分类加价率修改
export function category_increase_rate_save(data) {
	return request({
		url: 'yz/category_increase_rate_save',
		method: 'post',
		data
	})
}

// 有赞店铺商品导入
export function yz_goods_list_import(data) {
	return request({
		url: 'yz/goods_list_import',
		method: 'post',
		data
	})
}

// 有赞授权导入商品列表
export function yz_goods_list(data) {
	return request({
		url: 'yz_goods/list',
		method: 'post',
		data
	})
}

// 授权
export function authorization(data) {
	return request({
		url: 'jushuitan/authorization',
		method: 'post',
		data
	})
}

// 查询店铺
export function query_shops(data) {
	return request({
		url: 'jushuitan/query_shops',
		method: 'post',
		data
	})
}

// 获取订单日志列表
export function order_log_list(data) {
	return request({
		url: 'jushuitan/order_log_list',
		method: 'post',
		data
	})
}

// 获取公众号二维码
export function get_code(data) {
	return request({
		url: 'we_chat/authorization_code',
		method: 'post',
		data
	})
}

// 获取授权列表
export function get_authorization_list(data) {
	return request({
		url: 'we_chat/get_authorization_list',
		method: 'post',
		data
	})
}

// 取消用户授权
export function cancel_authorization(data) {
	return request({
		url: 'we_chat/cancel_authorization',
		method: 'post',
		data
	})
}

// 商品订阅列表
export function goods_subscribe_list(data) {
	return request({
		url: 'user/goods_subscribe_list',
		method: 'post',
		data
	})
}

// 取消订阅
export function cancel_goods_subscribe(data) {
	return request({
		url: 'user/cancel_goods_subscribe',
		method: 'post',
		data
	})
}

// 批量取消订阅
export function cancel_goods_subscribe_all(data) {
	return request({
		url: 'user/cancel_goods_subscribe_all',
		method: 'post',
		data
	})
}

// 侧边导航列表
export function interface_template_nav_list(data) {
	return request({
		url: 'test_tool/interface_template_nav_list',
		method: 'post',
		data
	})
}

// 字段列表
export function interface_template_field_list(data) {
	return request({
		url: 'test_tool/interface_template_field_list',
		method: 'post',
		data
	})
}

// API测试工具
export function interface_test(data) {
	return request({
		url: 'test_tool/interface_test',
		method: 'post',
		data
	})
}

// API测试工具
export function callback_interface_test(data) {
	return request({
		url: 'test_tool/callback_interface_test',
		method: 'post',
		data
	})
}

// 获取参数配置
export function get_configuration_parameter(data) {
	return request({
		url: 'test_tool/get_configuration_parameter',
		method: 'post',
		data
	})
}

// 应用列表
export function application_management_list(data) {
	return request({
		url: 'config/application_management_list',
		method: 'post',
		data
	})
}

// 短信验证码登录
export function mobile_login(data) {
	return request({
		// url: 'passport/mobile_login',
		url: 'V1/passport/mobile_login',
		method: 'post',
		data
	})
}

// 用户注销
export function user_cancellation_notice(data) {
	return request({
		url: 'user/user_cancellation_notice',
		method: 'post',
		data
	})
}
// 登录日志
export function register_log_list(data) {
	return request({
		url: 'user/register_log_list',
		method: 'post',
		data
	})
}

// 菜单接口
export function get_menu_list(data) {
	return request({
		url: 'shop_user/get_menu_list',
		method: 'post',
		data
	})
}

// 套餐列表
export function get_set_meal(data) {
	return request({
		url: 'set_meal/get_set_meal',
		method: 'post',
		data
	})
}

// 创建订单
export function save_order(data) {
	return request({
		url: 'set_meal/save_order',
		method: 'post',
		data
	})
}

// 获取订单
export function get_order_config(data) {
	return request({
		url: 'set_meal/get_order_config',
		method: 'post',
		data
	})
}

// 支付
export function mealpay(data) {
	return request({
		url: 'set_meal/pay',
		method: 'post',
		data
	})
}

// 订单列表
export function order_list(data) {
	return request({
		url: 'set_meal/order_list',
		method: 'post',
		data
	})
}